import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
const FIELD_CLASSES = 'flex h-9 w-full rounded-md border border-input bg-background px-3 py-1.5 text-sm shadow-sm ' +
    'ring-offset-background placeholder:text-muted-foreground ' +
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 ' +
    'disabled:cursor-not-allowed disabled:opacity-50';
export function Field({ label, hint, error, required, className, children }) {
    return (_jsxs("label", { className: cn('block space-y-1.5 text-sm', className), children: [label && (_jsxs("span", { className: "block text-xs font-medium text-foreground", children: [label, required && _jsx("span", { className: "text-red-600", children: " *" })] })), children, error ? (_jsx("span", { className: "block text-xs text-red-600", children: error })) : hint ? (_jsx("span", { className: "block text-xs text-muted-foreground", children: hint })) : null] }));
}
export function Input({ className, ...props }) {
    return _jsx("input", { ...props, className: cn(FIELD_CLASSES, className) });
}
export function Select({ className, children, ...props }) {
    return (_jsx("select", { ...props, className: cn(FIELD_CLASSES, 'pr-8', className), children: children }));
}
export function Textarea({ className, ...props }) {
    return (_jsx("textarea", { ...props, className: cn(FIELD_CLASSES, 'h-auto min-h-[80px] resize-y py-2', className) }));
}
